/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 商誉较大
 */

import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class Goodwill extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '商誉';
    }

    getColumns = () => {
        return [{
            title: '账面价值',
            dataIndex: 'goodWill'
        }, {
            title: '占所有者权益比例',
            dataIndex: 'goodWillPercent'
        }, {
            title: '较上年增减',
            dataIndex: 'goodWillChange'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/Goodwill.jsx